<script lang="ts">
    import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';
    import type { Retailer } from '@views/retailer/types';

    type Properties = {
        retailer?: Retailer;
        showMenu?: boolean;
        stacked?: boolean;
    };

    let { retailer, showMenu = true, stacked = false }: Properties = $props();

    /*                                                                                                                   */
    const MENU_SEPARATOR = ' | ';

    const encodeBase64 = (url: string) => {
        const bytes = new TextEncoder().encode(url);
        const binary = String.fromCodePoint(...bytes);
        return btoa(binary);
    };

    const trackRetailerContact = () => {
        trackEvent({ product_RetailerContent: ['contact'] });
    };

    const trackMenuItem = (urlParameter: string) => {
        trackEvent({ product_RetailerContent: [urlParameter] });
    };
</script>

{#if retailer}
    <div class="retailer" data-testid="retailer-info" data-ft5-visibility-tracking={'{"componentName":"retailer"}'}>
        <div class="retailer__info" class:retailer__info--stacked={stacked}>
            <span>Verkäufer:</span>
            <!-- svelte-ignore a11y_click_events_have_key_events -->
            <!-- svelte-ignore a11y_no_static_element_interactions -->
            <oc-interactive-overlay-v2
                class="retailer__info-overlay"
                data-oc-sheet-v1-create
                data-oc-sheet-v1-create.base64-url={encodeBase64(retailer.partnerLink)}
                data-oc-sheet-v1.headline="Verkäuferinformation"
                onclick={trackRetailerContact}
            >
                {#if retailer.isRetailerOtto}
                    <oc-logo-v1 oc-aria-label="otto-logo" fill-parent={true} logo="otto" class="retailer__info-overlay-logo"></oc-logo-v1>
                {:else}
                    <!-- @ts-expect-error -->
                    <oc-link-v2 class="retailer__info-overlay-link" as-button={true}>{retailer.name}</oc-link-v2>
                {/if}
            </oc-interactive-overlay-v2>
        </div>

        {#if showMenu}
            <div class="retailer__menu" data-testid="retailer-menu">
                {#each retailer.menuItems as menuItem, index (menuItem.urlParam)}{#if index > 0}
                        <span aria-hidden="true" class="oc-text-color-secondary oc-copy-100">{MENU_SEPARATOR}</span>{/if}
                    <!-- svelte-ignore a11y_click_events_have_key_events -->
                    <!-- svelte-ignore a11y_no_static_element_interactions -->
                    <oc-link-v2
                        variant="secondary"
                        data-oc-sheet-v1-create
                        data-oc-sheet-v1-create.base64-url={encodeBase64(menuItem.sheetUrl)}
                        onclick={() => trackMenuItem(menuItem.urlParam)}>{menuItem.title}</oc-link-v2
                    >{/each}
            </div>
        {/if}
    </div>
{/if}

<style lang="scss">
    .retailer {
        &__info {
            display: inline-flex;
            flex-direction: row;

            &--stacked {
                flex-direction: column;

                .retailer__info-overlay {
                    margin-left: 0;
                }
            }

            &-overlay {
                margin-left: 3px;
                display: inline-flex;
                flex-direction: column;

                &-logo {
                    width: 42px;
                }
            }
        }
    }
</style>
